import React, { useEffect, useState } from "react";
import "./assessment.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "../../../../axios";
import { Spinner, Alert } from "react-bootstrap";
import FailedDataUi from "../../../../Components/FailedDataUi";

function Assessment() {
  const [assessments, setAssessments] = useState(false);
  const [loading, setLoading] = useState(true); // added loading
  const navigate = useNavigate();
  const teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));

  useEffect(() => {
    const getPublishedAssessment = async () => {
      try {
        const res = await axios.get(
          `/api/v1/assessment/filterByTeacherId/${teacher_id}/published?_page=1`
        );
        if (res.data.data) {
          navigate("/publishedAssessment");
        } else {
          setAssessments(true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false); // hide loader after response
      }
    };

    getPublishedAssessment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "80vh" }}
      >
        <Spinner animation="border" variant="primary" role="status" />
        <span className="ms-2"></span>
      </div>
    );
  }

  return (
    <>
      {assessments ? (
        <div className="Addassemant_container">
          <div>
            <h3>Create an assessment</h3>
            <p>
              Create an assessment to measure the student's knowledge and
              skills.
            </p>
            <Link to="/create">
              <button id="addPreReadBtn">Create</button>
            </Link>
          </div>
        </div>
      ) : (
        <FailedDataUi />
      )}
    </>
  );
}

export default Assessment;
